export enum ImageFolder {
  EQUIPMENT_USER_IMAGES = 'equipment-user-images',
  EQUIPMENT_MODEL_IMAGES = 'equipment-model-images',
  USER_AVATARS = 'user-avatars',
}

export type Image = {
  src: string;
  id: number;
};

/**
 * Single source of truth for avatar formats, shared by the upload route, the
 * service that names the stored object, and the client dropzone.
 * svg is excluded on purpose: it is an XSS vector.
 */
export const AVATAR_MIME_EXTENSIONS: Record<string, string> = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'image/avif': 'avif',
};

export const AVATAR_MIME_TYPES = Object.keys(AVATAR_MIME_EXTENSIONS);

export enum ImageUsageContext {
  LOGO = 'LOGO',
  MODEL = 'MODEL',
  EQUIPMENT = 'EQUIPMENT',
  INSPECTION = 'INSPECTION',
  REPAIR = 'REPAIR',
}
